import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { useRightRail } from 'features/right_rail'

import { hideContextualHelp, showContextualHelp } from './slice'

export const useContextualHelp = () => {
  const dispatch = useDispatch()
  const { openOrReplace, close, current } = useRightRail()

  const openContextualHelp = useCallback(async (payload) => {
    openOrReplace('contextual_help')
    dispatch(showContextualHelp(payload))
  }, [dispatch, openOrReplace])

  const closeContextualHelp = useCallback(() => {
    close({ rail: { name: 'contextual_help', state: current?.paneState } })
    dispatch(hideContextualHelp())
  }, [dispatch, close, current])

  return {
    open: openContextualHelp,
    close: closeContextualHelp
  }
}
